var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{on:{"click":_vm.handleDownload}},[_vm._t("trigger",function(){return [(_vm.downloading)?_c('MIcon',{staticClass:"fa-spin",attrs:{"name":"spinner-third"}}):_vm._e(),_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.title)+" ")]},{"downloading":_vm.downloading})]},{"downloading":_vm.downloading})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }